export default "__VITE_ASSET__Bekf2_E2__"